import { sendEventToGTM } from "@/utils/Common";
import api from "./Axios";

export const submitSampleRequest = async (formData) => {
  try {
    const requestBody = {
      products: formData.products.map((p) => ({
        productName: p.productName,
        productId: p.productId ?? null,
        quantity: p.quantity,
      })),
      deliveryLocation: formData.deliveryLocation,
      fullName: formData.fullName,
      email: formData.email,
      companyName: formData.companyName,
      mobileNumber: formData.mobileNumber,
      timestamp: new Date().toISOString(),
      captcha: formData.recaptcha,
    };

    const response = await api.post("/contactus/sample-request/", requestBody);

    if (response?.data?.status === 200) {
      sendEventToGTM("SAMPLE_REQUEST_SUBMIT");
      return response?.data;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Error submitting sample request:", error);
    return false;
  }
};

export const submitContactForm = async (formData) => {
  try {
    const requestBody = {
      Name: formData.name,
      EmailId: formData.email,
      MobilewithCountryCode: formData.mobileNumber,
      Country: formData.country || "United States", // Default to US if not provided
      Services: "", // Empty for now as requested
      info: formData.message || "ignore this", // Use user's message or fallback
      recaptcha: formData.recaptcha,
      form_type: "US_FORM",
      // Optional catalogue id of the product the enquiry came from. Spread so that
      // callers which pass none send no `product` key at all, leaving every
      // existing consumer's request body unchanged.
      ...(formData.product ? { product: formData.product } : {}),
    };

    const response = await api.post("/contactus/", requestBody);

    if (response?.data?.status === 200) {
      sendEventToGTM("CONTACT_FORM_SUBMIT");
      return response?.data;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Error submitting contact form:", error);
    return false;
  }
};
